// extracted by mini-css-extract-plugin
export default {"SiteDarkGrey":"#5A6268","Footer":"Footer_Footer__IMVqG","active":"Footer_active__kS1U0","MadeIn":"Footer_MadeIn__KekJr","Link":"Footer_Link__7rPB3"};